export enum AuthApiEnum {
  Login = '/user/auth',
  Logout = '/user/logout',
  RefreshToken = '/user/refresh',
  UpdatePassword = '/user/password/',
}
